<template>
  <div>
    <template v-if="sabbaticalLeaveRequest.screen == 'approval'">
      <ApprovalSabbaticalLeave />
    </template>
    <template v-else>
      <div id="employee-detail">
        <CRow class="row-mobile">
          <CCol :md="{ size: 8, offset: 2 }" class="employees-form">
            <div class="text-center">
              <h4 class="title-header">
                {{ $t("label.label_sabbatical_leave_infomation") }}
              </h4>
            </div>
            <div class="text-content">
              <label>{{ $t("employee.label_employee_code") }}</label>
              <div class="show-text">
                {{ sabbaticalLeaveRequest.employee_id }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_name") }}</label>
              <div class="show-text">
                {{
                  sabbaticalLeaveRequest.employee
                    ? sabbaticalLeaveRequest.employee.name
                    : ""
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_position") }}</label>
              <div class="show-text">
                {{
                  sabbaticalLeaveRequest.employee
                    ? objectNotNull(sabbaticalLeaveRequest.employee.position)
                      ? sabbaticalLeaveRequest.employee.position.name
                      : ""
                    : ""
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_division") }}</label>
              <div class="show-text">
                {{
                  sabbaticalLeaveRequest.employee
                    ? objectNotNull(sabbaticalLeaveRequest.employee.department)
                      ? sabbaticalLeaveRequest.employee.department.name
                      : ""
                    : ""
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("commons.label_created_at") }}</label>
              <div class="show-text">
                {{ sabbaticalLeaveRequest.updated_at | formatDate }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_date_start") }}</label>
              <div class="show-text">
                {{ sabbaticalLeaveRequest.start_time }}
                {{ sabbaticalLeaveRequest.start_date | formatDate }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_date_end") }}</label>
              <div class="show-text">
                {{ sabbaticalLeaveRequest.end_time }}
                {{ sabbaticalLeaveRequest.end_date | formatDate }}
              </div>
            </div>

            <template v-if="sabbaticalLeaveRequest.reason_type != 4">
              <div class="text-content">
                <label>{{
                  $t("sabbatical-leave-request.label_number_days_leave")
                }}</label>
                <div class="show-text">
                  {{ sabbaticalLeaveRequest.number_days_off }}
                </div>
              </div>

              <div class="text-content">
                <label>{{
                  $t("sabbatical-leave-request.label_total_number_days_leaved")
                }}</label>
                <div class="show-text">
                  {{ sabbaticalLeaveRequest.total_sabbatical_leaved }}
                </div>
              </div>

              <div class="text-content">
                <label>{{
                  $t("sabbatical-leave-request.label_number_day_leave_remain")
                }}</label>
                <div class="show-text">
                  {{ sabbaticalLeaveRequest.total_remain_leave }}
                </div>
              </div>
            </template>

            <template v-else>
              <div class="text-content">
                <label>{{
                  $t("sabbatical-leave-request.label_number_minutes_leave")
                }}</label>
                <div class="show-text">
                  {{ Math.round(sabbaticalLeaveRequest.number_days_off * 8 * 60) }}
                </div>
              </div>

              <div class="text-content">
                <label>{{
                  $t("sabbatical-leave-request.label_total_number_minutes_leaved")
                }}</label>
                <div class="show-text">
                  {{ numberMinutesPhysiologicalLeaveOfMonth - (sabbaticalLeaveRequest.employee ? sabbaticalLeaveRequest.employee.number_of_physiological : 0)}}
                </div>
              </div>

              <div class="text-content">
                <label>{{
                  $t("sabbatical-leave-request.label_number_minute_leave_remain")
                }}</label>
                <div class="show-text">
                  {{ sabbaticalLeaveRequest.employee ? sabbaticalLeaveRequest.employee.number_of_physiological : 0 }}
                </div>
              </div>
            </template>

            <div class="text-content">
              <label>{{ $t("commons.label_reason") }}</label>
              <div class="show-text">
                {{
                  $t(
                    `commons.label_reason_sabbatical_leave_${sabbaticalLeaveRequest.reason_code}`
                  )
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("commons.label_sabbatical_leave_type") }}</label>
              <div class="show-text">
                {{
                  $t(
                    `commons.label_status_sabbatical_leave_type_${sabbaticalLeaveRequest.reason_type}`
                  )
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("commons.label_status") }}</label>
              <div class="show-text">
                {{
                  $t(
                    `commons.label_status_sabbatical_leave_request_${sabbaticalLeaveRequest.status}`
                  )
                }}
              </div>
            </div>
            <div class="text-content">
              <label class="label-note">{{ $t("sabbatical.note") }}</label>
              <div class="show-text" style="height: 80px;">
                {{ sabbaticalLeaveRequest.note }}
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="row-mobile">
          <CCol md="8" sm="12" class="employees-form approval-ot">
            <div class="text-label">
              <div class="text-center">
                <h4 class="title-header title-header-mb">
                  {{ $t("overtime.information_approval_ot") }}
                </h4>
              </div>
            </div>
            <div class="text-label-content">
              <div class="table-responsive table-employee-note">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="index">#</th>
                      <th class="create-by text-center">
                        {{ $t("overtime.employee_approval") }}
                      </th>
                      <th class="create-at text-center">
                        {{ $t("overtime.employee_approval_status") }}
                      </th>
                      <th class="text-center">
                        {{ $t("overtime.employee_approval_note") }}
                      </th>
                      <th class="text-center">
                        {{ $t("overtime.employee_approval_time") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-if="
                        sabbaticalLeaveRequest &&
                          sabbaticalLeaveRequest.sabbatical_leave_approves &&
                          sabbaticalLeaveRequest.sabbatical_leave_approves[0] &&
                          sabbaticalLeaveRequest.sabbatical_leave_approves[1] &&
                          sabbaticalLeaveRequest.sabbatical_leave_approves[0]
                            .employee_id ===
                            sabbaticalLeaveRequest.sabbatical_leave_approves[1]
                              .employee_id
                      "
                    >
                      <tr>
                        <th scope="row index">1</th>
                        <td class="text-center">
                          {{
                            sabbaticalLeaveRequest.sabbatical_leave_approves[0]
                              .employees[0].name
                          }}
                        </td>
                        <td class="text-center create-at">
                          {{
                            $t(
                              `overtime.employee_approval_${sabbaticalLeaveRequest.sabbatical_leave_approves[0].status}`
                            )
                          }}
                        </td>
                        <td class="text-center comment">
                          {{
                            sabbaticalLeaveRequest.sabbatical_leave_approves[0]
                              .comment
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            sabbaticalLeaveRequest.sabbatical_leave_approves[0]
                              .updated_at | formatDateTime
                          }}
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr
                        v-for="(item,
                        index) in sabbaticalLeaveRequest.sabbatical_leave_approves"
                        :key="index"
                      >
                        <th scope="row index">{{ index + 1 }}</th>
                        <td class="text-center">{{ item.employees[0].name }}</td>
                        <td class="text-center create-at">
                          {{ $t(`overtime.employee_approval_${item.status}`) }}
                        </td>
                        <td class="text-center comment">{{ item.comment }}</td>
                        <td class="text-center" v-if = " item.status != 1">
                          {{ item.updated_at | formatDateTime }}
                        </td>
                        <td v-else>
                          
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="mobile-row-btn" v-if="new Date(sabbaticalLeaveRequest.start_date).getMonth() == new Date().getMonth()">
          <CCol md="12" sm="12" class="text-center">
            <router-link
              v-if="sabbaticalLeaveRequest.status === 1"
              class="btn btn-success"
              :to="{
                path: `/sabbatical-leave-request/update/${sabbaticalLeaveRequest.id}`,
                params: { id: sabbaticalLeaveRequest.id }
              }"
              tag="a"
            >
              <CIcon
                name="cil-pencil"
                style="margin-right: 3px; border: 1px solid #fff;"
              ></CIcon>
              {{ $t("button.label_action_edit") }}
            </router-link>
          </CCol>
        </CRow>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import ApprovalSabbaticalLeave from "./ApprovalSabbaticalLeave";

export default {
  name: "Detail",
  components: {
    ApprovalSabbaticalLeave
  },
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_leave_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      numberMinutesPhysiologicalLeaveOfMonth: 90
    };
  },

  computed: {
    ...mapGetters({
      sabbaticalLeaveRequest: "sabbatical-leave-request/sabbaticalLeaveRequest",
      flagNotification: "commons/flagNotification"
    })
  },

  methods: {
    ...mapMutations("commons", ["setNotificationFlag"]),

    async showSabbaticalLeaveRequest() {
      let sabbaticalLeaveRequestId = this.$route.params.id;
      await this.$store.dispatch(
        "sabbatical-leave-request/detailSabbaticalLeaveRequest",
        sabbaticalLeaveRequestId
      );
      this.setNotificationFlag(false);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    }
  },

  created() {
    this.showSabbaticalLeaveRequest();
  },

  watch: {
    async flagNotification(value) {
      if (value) {
        await this.showSabbaticalLeaveRequest();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 767px) {
  .table {
    width: 550px;
  }
  .mobile-row-btn {
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 15px !important;
  }
  .row-mobile {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  #employee-detail,
  #employee-detail .employees-form {
    padding: 0.3rem !important;
  }
  #employee-detail {
    .employees-form {
      .text-content {
        display: block !important;
        label {
          width: 100% !important;
        }
      }
      .show-text {
        width: 100% !important;
      }
    }
    .title-header {
      margin-bottom: 2rem !important;
      margin-top: 25px !important;
    }
    .title-header-mb {
      margin-top: 0 !important;
    }
  }
  .label-note {
    height: 0px !important;
  }
}
#employee-detail {
  padding: 20px 100px;
  .title-header {
    margin-bottom: 47px;
    border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }
  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;
    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 30px;
      .icon-text-label {
        margin-left: 8px;
      }
    }
    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .image {
        width: 70%;
      }
      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }
    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .text-area {
      height: 60px;
    }
    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }
  #toggle-btn {
    height: 37px;
  }
  .employees-form.approval-ot {
    margin: auto;

    .table-employee-note {
      background-color: white;
      margin-top: 20px;

      th {
        font-size: 15px;
      }

      td {
        color: #3c4b64;
      }

      td.comment {
        max-width: 300px;
        word-wrap: break-word;
      }
    }
  }
}
.label-note {
  height: 72px;
}
</style>
